export default __webpack_public_path__ + "static/media/logo-boleto.e76d2f2a.png";